<template>
    <CCard class="page mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol>
                    <h1 class="page__title">{{ $t(titlePage) }}</h1>
                </CCol>
                <CCol class="d-flex justify-content-end">
                    <ButtonBack class="mr-3" title="Go back" />
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer class="section" fluid>
                <CRow alignHorizontal="center"
                    v-show="
                        hasItemsInTable({
                            tableName: 'subTags',
                        })
                    "
                >
                    <CCol md="12">
                        <CCard>
                            <CCardBody>
                                <CRow class="border-bottom">
                                    <CCol >
                                        <CBreadcrumb class="background-full-white" :items="breadItems"/>
                                    </CCol>
                                </CRow>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.subTags.fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :itemsPerPageSelect="{
                                        values: [5, 10, 20],
                                    }"
                                    :columnFilterValue.sync="
                                        tables.subTags.columnFilterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.subTags.rows"
                                    v-bind="tables.subTags"
                                >
                                <template #name="{ item }" >
                                    <td>
                                        <a  class="bread-ancord"
                                            @click="
                                                $router.push({
                                                    name: 'sub_tag_fields',
                                                    query: { 
                                                        uuid: item.uuid,
                                                        subTagName: item.name,
                                                        tagName: name,
                                                        tagUuid: uuid
                                                    },
                                                })
                                            "
                                        >
                                            {{item.name}}
                                            <!-- {{ (item.file_name) ? item.file_name:'' }} -->
                                        </a>
                                    </td>
                                </template>
                                </CDataTable>
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
            <NoItemsContainer
                v-show="
                    !hasItemsInTable({
                        tableName: 'subTags'
                    })
                "
            >
                <template #title>
                    Not Found Sub Tags
                </template>
                <template #description>
                    {{'Generar una descripción de los sub tags'}}
                    <ButtonBack class="mt-4 mr-2" title="Go back" />
                </template>
                <template #cleanFilter>
                    <CButton
                        color="primary"
                        class="button"
                        v-show="
                            hasFiltersInTable({
                                tableName: 'subTags' 
                            })
                        "
                        @click="cleanFiltersAdvance('subTags'), updateData()"
                    >
                        <span class="button__icon">
                            <CIcon
                                :content="$options.icons.eraser"
                            />
                        </span>
                        <span class="button__text">
                            {{ $t("Clean Filter") }}
                        </span>
                    </CButton>
                </template>
            </NoItemsContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import ButtonBack from "£lement/ButtonBack";
import ButtonLoading from "~/components/ButtonLoading.vue";
import NoItemsContainer from "~/components/NoItemsContainer";

/** Mixins */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table";
import traslateMixin from "~/mixins/traslate.js";
/** Icons */
import { eraser }  from '~/assets/icons/js/eraser';
/** Others */
import { 
    cilTrash,
    cilArrowBottom,
    cilArrowTop,
    cilPlus,
    cilPencil,
    cilCaretBottom,
    cilCaretTop,
    cilSave
} from "@coreui/icons";

export default {
    name: "TagViewPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin, traslateMixin],
    components: {
        ButtonBack,
        ButtonLoading,
        NoItemsContainer
    },
    icons: {
        cilTrash,
        cilArrowTop,
        cilArrowBottom,
        cilPencil,
        cilCaretBottom,
        cilCaretTop,
        cilPlus,
        cilSave,
        eraser
    },
    data() {
        return {
            tables: {
                subTags: {
                    items: [],
                    fields: [
                        {
                            label: "id",
                            key: "id",
                            sorter: false,
                            filter: true,
                        },
                        {
                            label: "name",
                            key: "name",
                            sorter: false,
                            filter: true,
                        },
                        {
                            label: "code",
                            key: "code",
                            sorter: false,
                            filter: true,
                        },
                        {
                            key: "createdAt",
                            label: "created_at",
                            sorter: false,
                            filter: false,
                            _style: "width:20%",
                        }
                    ],
                    order: "desc",
                    rows: 10,
                    page: 1,
                    total_pages: 0,
                    loading: true,
                    pagination: true,
                    sorter: true,
                    responsive: true,
                    columnFilter: {
                        external: true,
                        lazy: true,
                    },
                    columnFilterValue: {},
                    itemsPerPageSelect: true,
                },
            },
            breadItems:[
                {
                    text: 'Tags',
                    to: '/app/documentation/headers'
                },
                {
                    text: this.$route.query.name
                }
            ]
        };
    },
    computed: {
        uuid: function () {
            return this.$route.query.uuid;
        },
        name: function () {
            return this.$route.query.name;
        },
    },
    methods: {
        itemPerPage(newValue) {
            this.tables.subTags.rows = newValue;
            this.updatePagination(this.tables.subTags.page);
        },
        updatePagination(newValue) {
            this.tables.subTags.page = newValue;
            this.updateData();
        },
        async updateData() {
            await this.updateTable({
                tableName: "subTags",
                url: `/tags/${this.uuid}/sub-tags`,
                fetch: {
                    baseURL: process.env.VUE_APP_API_CORE,
                },
                adapterFilters: (filters)=>{
                    delete filters.where.created_at
                    return filters;
                }
            });
            this.tables.subTags.loading = false;
            this.updatePageLoading(false);
        },
    },
    async mounted() {
        await this.updateData();
    },
};
</script>

<style lang="scss" scoped>
.input-fields {
    margin-bottom: 1rem;
}
.background-full-white{
    background-color: #fff;
    border-color: #fff;
}
.bread-ancord{
    color:#007bff;
    cursor:pointer;
}
</style>
